module.exports = __webpack_public_path__ + "img/dijets-paper-wallet.10621d86.png";